import { UserInformationModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';

export class CurrentUser extends DomainEntity<UserInformationModelDto> {
    public createDefault() {
        return new CurrentUser({} as UserInformationModelDto) as this;
    }

    public get userId() {
        return this.dto.userId;
    }

    public get loginId() {
        return this.dto.loginId;
    }

    public get isAdmin() {
        return this.dto.isAdmin;
    }

    public get name() {
        return this.dto.name;
    }
}
